import { render, staticRenderFns } from "./WallConstruction.vue?vue&type=template&id=38f6bc19&"
import script from "./WallConstruction.vue?vue&type=script&lang=ts&"
export * from "./WallConstruction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports